// @ts-nocheck — migrated from JS; reactstrap / react-select / layout prop friction.
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Form
} from "reactstrap";
import Select from "react-select";
import CustomSelect from "Components/CustomSelect";
import moment from "moment";
import Switch from "rc-switch";
import ReactAutosuggest from "Components/ReactAutosuggest";
import Rating from "Components/Rating";
import { SliderTooltip, RangeTooltip } from "Components/SliderTooltip";
import { GALLERY_THUMB_OBJECT_COVER } from "Constants/reactifyInlineStyles";

import "rc-switch/assets/index.css";
import "rc-slider/assets/index.css";
import "react-rater/lib/react-rater.css";

const countries = [
  {
    name: "Afghanistan"
  },
  {
    name: "Albania"
  },
  {
    name: "Algeria"
  },
  {
    name: "Andorra"
  },
  {
    name: "Angola"
  },
  {
    name: "Argentina"
  },
  {
    name: "Armenia"
  },
  {
    name: "Aruba"
  },
  {
    name: "Australia"
  },
  {
    name: "Austria"
  },
  {
    name: "Azerbaijan"
  },
  {
    name: "Bahamas, The"
  },
  {
    name: "Bahrain"
  },
  {
    name: "Bangladesh"
  },
  {
    name: "Barbados"
  },
  {
    name: "Belarus"
  },
  {
    name: "Belgium"
  },
  {
    name: "Belize"
  },
  {
    name: "Benin"
  },
  {
    name: "Bhutan"
  },
  {
    name: "Bolivia"
  },
  {
    name: "Bosnia and Herzegovina"
  },
  {
    name: "Botswana"
  },
  {
    name: "Brazil"
  },
  {
    name: "Brunei"
  },
  {
    name: "Bulgaria"
  },
  {
    name: "Burkina Faso"
  },
  {
    name: "Burma"
  },
  {
    name: "Burundi"
  },
  {
    name: "Cambodia"
  },
  {
    name: "Cameroon"
  },
  {
    name: "Canada"
  },
  {
    name: "Central African Republic"
  },
  {
    name: "Chad"
  },
  {
    name: "Chile"
  },
  {
    name: "China"
  },
  {
    name: "Colombia"
  },
  {
    name: "Comoros"
  },
  {
    name: "Congo, Democratic Republic of the"
  },
  {
    name: "Congo, Republic of the"
  },
  {
    name: "Costa Rica"
  },
  {
    name: "Cote d'Ivoire"
  },
  {
    name: "Croatia"
  },
  {
    name: "Cuba"
  },
  {
    name: "Curacao"
  },
  {
    name: "Cyprus"
  },
  {
    name: "Czechia"
  },
  {
    name: "Denmark"
  },
  {
    name: "Djibouti"
  },
  {
    name: "Dominica"
  },
  {
    name: "Dominican Republic"
  },
  {
    name: "Ecuador"
  },
  {
    name: "Egypt"
  },
  {
    name: "El Salvador"
  },
  {
    name: "Equatorial Guinea"
  },
  {
    name: "Eritrea"
  },
  {
    name: "Estonia"
  },
  {
    name: "Eswatini"
  },
  {
    name: "Ethiopia"
  },
  {
    name: "Fiji"
  },
  {
    name: "Finland"
  },
  {
    name: "France"
  },
  {
    name: "Gabon"
  },
  {
    name: "Gambia, The"
  },
  {
    name: "Georgia"
  },
  {
    name: "Germany"
  },
  {
    name: "Ghana"
  },
  {
    name: "Greece"
  },
  {
    name: "Grenada"
  },
  {
    name: "Guatemala"
  },
  {
    name: "Guinea"
  },
  {
    name: "Guinea-Bissau"
  },
  {
    name: "Guyana"
  },
  {
    name: "Haiti"
  },
  {
    name: "Holy See"
  },
  {
    name: "Honduras"
  },
  {
    name: "Hong Kong"
  },
  {
    name: "Hungary"
  },
  {
    name: "Iceland"
  },
  {
    name: "India"
  },
  {
    name: "Indonesia"
  },
  {
    name: "Iran"
  },
  {
    name: "Iraq"
  },
  {
    name: "Ireland"
  },
  {
    name: "Israel"
  },
  {
    name: "Italy"
  },
  {
    name: "Jamaica"
  },
  {
    name: "Japan"
  },
  {
    name: "Jordan"
  },
  {
    name: "Kazakhstan"
  },
  {
    name: "Kenya"
  },
  {
    name: "Kiribati"
  },
  {
    name: "Korea, North"
  },
  {
    name: "Korea, South"
  },
  {
    name: "Kosovo"
  },
  {
    name: "Kuwait"
  },
  {
    name: "Kyrgyzstan"
  },
  {
    name: "Laos"
  },
  {
    name: "Latvia"
  },
  {
    name: "Lebanon"
  },
  {
    name: "Lesotho"
  },
  {
    name: "Liberia"
  },
  {
    name: "Libya"
  },
  {
    name: "Liechtenstein"
  },
  {
    name: "Lithuania"
  },
  {
    name: "Luxembourg"
  },
  {
    name: "Madagascar"
  },
  {
    name: "Malawi"
  },
  {
    name: "Malaysia"
  },
  {
    name: "Maldives"
  },
  {
    name: "Mali"
  },
  {
    name: "Malta"
  },
  {
    name: "Marshall Islands"
  },
  {
    name: "Mauritania"
  },
  {
    name: "Mauritius"
  },
  {
    name: "Mexico"
  },
  {
    name: "Micronesia"
  },
  {
    name: "Moldova"
  },
  {
    name: "Monaco"
  },
  {
    name: "Mongolia"
  },
  {
    name: "Montenegro"
  },
  {
    name: "Morocco"
  },
  {
    name: "Mozambique"
  },
  {
    name: "Namibia"
  },
  {
    name: "Nauru"
  },
  {
    name: "Nepal"
  },
  {
    name: "Netherlands"
  },
  {
    name: "New Zealand"
  },
  {
    name: "Nicaragua"
  },
  {
    name: "Niger"
  },
  {
    name: "Nigeria"
  },
  {
    name: "North Korea"
  },
  {
    name: "North Macedonia"
  },
  {
    name: "Norway"
  },
  {
    name: "Oman"
  },
  {
    name: "Pakistan"
  },
  {
    name: "Palau"
  },
  {
    name: "Palestinian Territories"
  },
  {
    name: "Panama"
  },
  {
    name: "Papua New Guinea"
  },
  {
    name: "Paraguay"
  },
  {
    name: "Philippines"
  },
  {
    name: "Poland"
  },
  {
    name: "Portugal"
  },
  {
    name: "Qatar"
  },
  {
    name: "Romania"
  },
  {
    name: "Russia"
  },
  {
    name: "Rwanda"
  },
  {
    name: "Saint Kitts and Nevis"
  },
  {
    name: "Saint Lucia"
  },
  {
    name: "Saint Vincent and the Grenadines"
  },
  {
    name: "Samoa"
  },
  {
    name: "San Marino"
  },
  {
    name: "Sao Tome and Principe"
  },
  {
    name: "Saudi Arabia"
  },
  {
    name: "Senegal"
  },
  {
    name: "Serbia"
  },
  {
    name: "Seychelles"
  },
  {
    name: "Sierra Leone"
  },
  {
    name: "Singapore"
  },
  {
    name: "Sint Maarten"
  },
  {
    name: "Slovakia"
  },
  {
    name: "Solomon Islands"
  },
  {
    name: "Somalia"
  },
  {
    name: "South Africa"
  },
  {
    name: "South Korea"
  },
  {
    name: "South Sudan"
  },
  {
    name: "Spain"
  },
  {
    name: "Sri Lanka"
  },
  {
    name: "Sudan"
  },
  {
    name: "Suriname"
  },
  {
    name: "Swaziland"
  },
  {
    name: "Sweden"
  },
  {
    name: "Switzerland"
  },
  {
    name: "Syria"
  },
  {
    name: "Taiwan"
  },
  {
    name: "Tajikistan"
  },
  {
    name: "Tanzania"
  },
  {
    name: "Thailand"
  },
  {
    name: "Timor-Leste"
  },
  {
    name: "Togo"
  },
  {
    name: "Tonga"
  },
  {
    name: "Trinidad and Tobago"
  },
  {
    name: "Turkey"
  },
  {
    name: "Turkmenistan"
  },
  {
    name: "Tuvalu"
  },
  {
    name: "Uganda"
  },
  {
    name: "Ukraine"
  },
  {
    name: "United Arab Emirates"
  },
  {
    name: "United Kingdom"
  },
  {
    name: "Uruguay"
  },
  {
    name: "Uzbekistan"
  },
  {
    name: "Vanuatu"
  },
  {
    name: "Venezuela"
  },
  {
    name: "Vietnam"
  },
  {
    name: "Yemen"
  },
  {
    name: "Zambia"
  },
  {
    name: "Zimbabwe"
  }
];

const Gender = [
  { label: "Male", value: "male", key: 0 },
  { label: "Female", value: "female", key: 1 }
];
const Hobbies = [
  { label: "Playing Football", value: "football", key: 0 },
  { label: "Playing Cricket", value: "cricket", key: 1 },
  { label: "Collecting Coins", value: "coins", key: 0 },
  { label: "Traveling", value: "traveling", key: 1 },
  { label: "Cooking", value: "cooking", key: 1 }
];

function formatDemoFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function FormInputs() {
  const demoGalleryInputRef = useRef(null);
  const demoGalleryDragDepthRef = useRef(0);
  const demoGalleryFilesRef = useRef([]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [switchCheckedBox, setSwitchCheckedBox] = useState(false);
  const [, setSwitchCheckedBoxInverse] = useState(true);
  const [switchCheckedBoxS, setSwitchCheckedBoxS] = useState(true);
  const [, setSwitchCheckedBoxSInverse] = useState(false);
  const [, setSuggestionValue] = useState("");
  const [, setSuggestions] = useState([]);
  const [demoGalleryFiles, setDemoGalleryFiles] = useState([]);
  const [demoGalleryDragActive, setDemoGalleryDragActive] = useState(false);
  const [, setTags] = useState();

  useEffect(() => {
    demoGalleryFilesRef.current = demoGalleryFiles;
  }, [demoGalleryFiles]);

  useEffect(() => {
    return () => {
      demoGalleryFilesRef.current.forEach(item => {
        if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
      });
    };
  }, []);

  const addDemoGalleryFiles = useCallback(fileList => {
    const files = Array.from(fileList || []).filter(Boolean);
    if (!files.length) return;
    setDemoGalleryFiles(prev => [
      ...prev,
      ...files.map(file => ({
        id: `${file.name}-${file.size}-${Date.now()}-${Math.random()
          .toString(36)
          .slice(2, 9)}`,
        file,
        previewUrl:
          file.type && file.type.startsWith("image/")
            ? URL.createObjectURL(file)
            : null
      }))
    ]);
  }, []);

  const removeDemoGalleryFile = useCallback(id => {
    setDemoGalleryFiles(prev => {
      const item = prev.find(f => f.id === id);
      if (item && item.previewUrl) URL.revokeObjectURL(item.previewUrl);
      return prev.filter(f => f.id !== id);
    });
  }, []);

  const onDemoGalleryInputChange = useCallback(
    e => {
      addDemoGalleryFiles(e.target.files);
      e.target.value = "";
    },
    [addDemoGalleryFiles]
  );

  const onDemoGalleryDragEnter = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    demoGalleryDragDepthRef.current += 1;
    if (demoGalleryDragDepthRef.current === 1) {
      setDemoGalleryDragActive(true);
    }
  }, []);

  const onDemoGalleryDragLeave = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    demoGalleryDragDepthRef.current -= 1;
    if (demoGalleryDragDepthRef.current <= 0) {
      demoGalleryDragDepthRef.current = 0;
      setDemoGalleryDragActive(false);
    }
  }, []);

  const onDemoGalleryDragOver = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const onDemoGalleryDrop = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      demoGalleryDragDepthRef.current = 0;
      setDemoGalleryDragActive(false);
      if (e.dataTransfer.files && e.dataTransfer.files.length) {
        addDemoGalleryFiles(e.dataTransfer.files);
      }
    },
    [addDemoGalleryFiles]
  );

  const onSuggestionChange = useCallback((event, { newValue }) => {
    setSuggestionValue(newValue);
  }, []);

  const handleTagChange = useCallback(tags => {
    setTags(tags);
  }, []);

  const handleChangeMulti = useCallback(selected => {
    setSelectedOptions(selected);
  }, []);

  const handleChange = useCallback(selected => {
    setSelectedOption(selected);
  }, []);

  return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.forms-input" />}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <Row>
                  <Colxx lg="12">
                    <Form>
                      <FormGroup>
                        <Label for="exampleEmail">Email</Label>
                        <Input
                          type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder="with a placeholder"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Input
                          type="password"
                          name="password"
                          id="examplePassword"
                          placeholder="password placeholder"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleSelect">Select</Label>
                        <Input type="select" name="select" id="exampleSelect">
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleSelectMulti">Select Multiple</Label>
                        <Input
                          type="select"
                          name="selectMulti"
                          id="exampleSelectMulti"
                          multiple
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleText">Text Area</Label>
                        <Input type="textarea" name="text" id="exampleText" />
                      </FormGroup>
                    </Form>
                  </Colxx>
                  <Colxx xxs="12" md="6" className="mb-5">
                    <label>Gender</label>
                    <Select
                      components={{ Input: CustomSelect }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="form-field-name"
                      value={selectedOption}
                      onChange={handleChange}
                      options={Gender}
                    />
                  </Colxx>
                  <Colxx xxs="12" md="6">
                    <label>Hobbies</label>
                    <Select
                      components={{ Input: CustomSelect }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti
                      name="form-field-name"
                      value={selectedOptions}
                      onChange={handleChangeMulti}
                      options={Hobbies}
                    />
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <Row>
                  <Colxx xxs="12" sm="6">
                    <ReactAutosuggest
                      placeholder="Select Country"
                      data={countries}
                      onChange={value => {}}
                    />
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx lg="4">
            <Card>
              <CardBody>
                <Form>
                  <FormGroup>
                    <FormGroup check>
                      <Input type="checkbox" id="exCustomCheckbox" />
                      <Label for="exCustomCheckbox" check>
                        Checkbox
                      </Label>
                    </FormGroup>
                    <FormGroup check>
                      <Input type="checkbox" id="exCustomCheckbox3" disabled />
                      <Label for="exCustomCheckbox3" check>
                        Disbaled
                      </Label>
                    </FormGroup>
                  </FormGroup>
                  <FormGroup>
                    <FormGroup check>
                      <Input type="radio" id="CustomRadio" name="customRadio" />
                      <Label for="CustomRadio" check>
                        Radio Button
                      </Label>
                    </FormGroup>
                    <FormGroup check>
                      <Input
                        type="radio"
                        id="customRadioD"
                        name="customRadio"
                        disabled
                      />
                      <Label for="customRadioD" check>
                        Disabled
                      </Label>
                    </FormGroup>
                  </FormGroup>
                  <FormGroup className="d-flex flex-wrap gap-3">
                    <FormGroup check className="form-check-inline">
                      <Input type="checkbox" id="CustomInlineCheckbox" />
                      <Label for="CustomInlineCheckbox" check>
                        Inline
                      </Label>
                    </FormGroup>
                    <FormGroup check className="form-check-inline">
                      <Input type="checkbox" id="CustomInlineCheckboxx" />
                      <Label for="CustomInlineCheckboxx" check>
                        Second
                      </Label>
                    </FormGroup>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
          </Colxx>

          <Colxx lg="8">
            <Card>
              <CardBody>
                <Colxx xxs="12">
                  <Row>
                    <Switch
                      className="custom-switch custom-switch-primary mr-2 my-2"
                      checked={switchCheckedBox}
                      onChange={setSwitchCheckedBox}
                    />
                    <Switch
                      className="custom-switch custom-switch-primary my-2"
                      checked={switchCheckedBoxS}
                      onChange={setSwitchCheckedBoxS}
                    />
                  </Row>
                  <Rating total={5} rating={0} onRate={rating => {}} />

                  <Rating total={5} rating={5} interactive={false} />

                  <div className="mb-5">
                    <RangeTooltip
                      min={50}
                      max={5000}
                      className="mb-5"
                      defaultValue={[500, 1500]}
                      allowCross={false}
                      pushable={50}
                    />
                  </div>
                  <div className="mt-5">
                    <SliderTooltip
                      min={500}
                      max={5000}
                      defaultValue={900}
                      className="mb-5"
                    />
                  </div>
                </Colxx>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <input
                  ref={demoGalleryInputRef}
                  type="file"
                  multiple
                  className="d-none"
                  onChange={onDemoGalleryInputChange}
                />
                <div
                  className={`react-fine-uploader-gallery-dropzone position-relative ${
                    demoGalleryDragActive
                      ? "react-fine-uploader-gallery-dropzone-active"
                      : ""
                  }`}
                  onDragEnter={onDemoGalleryDragEnter}
                  onDragLeave={onDemoGalleryDragLeave}
                  onDragOver={onDemoGalleryDragOver}
                  onDrop={onDemoGalleryDrop}
                  role="presentation"
                >
                  {demoGalleryFiles.length === 0 ? (
                    <button
                      type="button"
                      className="btn btn-link w-100 border-0 text-decoration-none react-fine-uploader-gallery-dropzone-content d-block py-5"
                      onClick={() =>
                        demoGalleryInputRef.current &&
                        demoGalleryInputRef.current.click()
                      }
                    >
                      <span className="fa fa-cloud-upload-alt font-color-1 fa-3x d-block mb-2" />
                      <span className="text-muted small d-block">
                        Click or drop files here (demo — files stay in the
                        browser only)
                      </span>
                    </button>
                  ) : (
                    <>
                      <ul className="react-fine-uploader-gallery-files list-unstyled clearfix mb-0">
                        {demoGalleryFiles.map(item => (
                          <li
                            key={item.id}
                            className="react-fine-uploader-gallery-file"
                          >
                            <div className="react-fine-uploader-gallery-thumbnail-container position-relative d-flex align-items-center justify-content-center">
                              {item.previewUrl ? (
                                <img
                                  src={item.previewUrl}
                                  alt=""
                                  className="react-fine-uploader-gallery-thumbnail"
                                  style={GALLERY_THUMB_OBJECT_COVER}
                                />
                              ) : (
                                <span className="fa fa-file-o fa-2x text-muted" />
                              )}
                            </div>
                            <div className="react-fine-uploader-gallery-file-footer">
                              <div
                                className="react-fine-uploader-filename react-fine-uploader-gallery-filename text-truncate"
                                title={item.file.name}
                              >
                                {item.file.name}
                              </div>
                              <div className="react-fine-uploader-gallery-status">
                                {formatDemoFileSize(item.file.size)}
                              </div>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger mt-2"
                                onClick={() => removeDemoGalleryFile(item.id)}
                              >
                                Delete
                              </button>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <div className="p-3 text-center border-top">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          onClick={() =>
                            demoGalleryInputRef.current &&
                            demoGalleryInputRef.current.click()
                          }
                        >
                          Add more files
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
  );
}

export default FormInputs;
